module.exports = __webpack_public_path__ + "img/logobe.f94455b5.svg";